module.exports = __webpack_public_path__ + "img/shopping_icon.a80e3542.svg";